import React from 'react';
import { connect } from 'react-redux';

import { setSitesFromServer } from '../../../actions';
import { selectedServersId } from '../../../actions/selectedElement';
import { toastSuccess, toastError } from '../../../utils/toastr';

import Edit from './edit';
import Delete from './delete';
import Add from './add';

import requestAPI from 'helpers/requestAPI';

import { List } from 'antd';

const ListItems = ({ setSites, selectedServersId }) => {
	const [ options, setOptions ] = React.useState([]);

	React.useEffect(() => {
		const params = {
			routeParams: {
				route: 'servers'
			}
		};

		requestAPI(params)
			.then((response) => {
				const serversList = response.data.data.map((el) => (
					<div className="list__item" key={el.id}>
						<div className="list__item__title" data-value={el.id} onClick={onClick}>
							{el.name}
						</div>
						<div className="list__item__functional-buttons">
							<Edit serverId={el.id} />
							<Delete serverId={el.id} />
						</div>
					</div>
				));

				setOptions(serversList);
			})
			.catch((error) => {
				toastError(error);
			});
		// eslint-disable-next-line
	}, []);

	const onClick = React.useCallback(event => {
		const serverId = event.target.getAttribute('data-value');

		selectedServersId(serverId);

		const params = {
			routeParams: {
				route: 'servers',
				serverId
			},
			method: 'POST'
		};

		requestAPI(params)
			.then((response) => {

					const data = response.data.data.map((item) => {
						return {
							value: item.site,
							label: item.site,
							title: item.id,
							showCheckbox: false,
							children: [
								{ value: 'waiting server response...', label: 'waiting server response...', showCheckbox: false }
							]
						};
					});

					console.log(data);

					setSites(data);
					toastSuccess('Done');
			})
			.catch((error) => {
				toastError(error.response.data.error);
			});
	}, [selectedServersId, setSites]);

	return (
		<List
			size="small"
			header={<div className="list__header">Choose server:</div>}
			footer={<Add />}
			bordered
			dataSource={options}
			renderItem={(item) => <List.Item>{item}</List.Item>}
		/>
	);
};

const mapStateToProps = ({ sitesFromServer }) => {
	return { sitesFromServer };
};

const mapDispatchToProps = (dispatch) => ({
	setSites: (data) => dispatch(setSitesFromServer(data)),
	selectedServersId: (data) => dispatch(selectedServersId(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ListItems);
